"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.messageNotificationGlossary = void 0;
const enums_1 = require("../enums");
exports.messageNotificationGlossary = {
    latestVersion: 1,
    1: {
        pushHeadings: ({ localizations }) => localizations.reduce((acc, { locale, shortTitle }) => {
            acc[locale] = shortTitle;
            return acc;
        }, enums_1.NotificationLanguagesEnum),
        pushContents: ({ localizations }) => localizations.reduce((acc, { locale, title }) => {
            acc[locale] = title;
            return acc;
        }, enums_1.NotificationLanguagesEnum),
        telegramBody: ({ localizations }) => localizations.reduce((acc, { locale, title }) => {
            acc[locale] = title;
            return acc;
        }, enums_1.NotificationLanguagesEnum),
    },
};
